import { forwardRef, type Ref, type SVGProps } from "react";
const IconWarningOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="m29.75 26-12-22a2 2 0 0 0-3.52 0l-12 22A2 2 0 0 0 4 29h24a2 2 0 0 0 1.75-3M4 27 16 5l12 22z" />
    <path d="M16 22.5a1.49 1.49 0 0 0-1.5 1.5 1.5 1.5 0 0 0 1.5 1.5 1.49 1.49 0 0 0 1.5-1.5 1.48 1.48 0 0 0-1.5-1.5M16 11a1.68 1.68 0 0 0-1.74 1.79l.69 6.4a1.09 1.09 0 0 0 2.11 0l.68-6.4A1.67 1.67 0 0 0 16 11" />
  </svg>
);
const ForwardRef = forwardRef(IconWarningOutlineSVG);
ForwardRef.displayName = "IconWarningOutline";
export { ForwardRef as IconWarningOutline };
